/** The screen names used for analytics
 *
 * IMPORTANT: Any changes to this file should be updated in the analytics spreadsheet at
 * https://docs.google.com/spreadsheets/d/1yJgBdbk-bSrhM21EsqAaMisJEyRTSp4yLm5gfIH0SKs/edit?usp=sharing
 *
 */

export enum Screens {
  // Static screens
  TOKEN_IN_PARTNER_REVIEW = 'TOKEN_IN_PARTNER_REVIEW',
  TOKEN_IN_REVIEW = 'TOKEN_IN_REVIEW',
  TOKEN_IN_MANUAL_REVIEW = 'TOKEN_IN_MANUAL_REVIEW',
  TOKEN_REJECTED = 'TOKEN_REJECTED',
  TOKEN_ACTIVE = 'TOKEN_ACTIVE',
  TOKEN_FROZEN = 'TOKEN_FROZEN',
  TOKEN_REVOKED = 'TOKEN_REVOKED',
  TOKEN_REFRESH_IN_REVIEW = 'TOKEN_REFRESH_IN_REVIEW',
  CONTINUE = 'CONTINUE',
  CANCEL = 'CANCEL',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  VALIDATION_STATUS = 'VALIDATION_STATUS',
  DOCUMENT_FINALIZING = 'DOCUMENT_FINALIZING',
  DOCUMENT_IN_PROGRESS = 'DOCUMENT_IN_PROGRESS',
  DOCUMENT_IN_REVIEW = 'DOCUMENT_IN_REVIEW',
  DOCUMENT_REJECTED = 'DOCUMENT_REJECTED',
  DOCUMENT_MOBILE_HANDOFF_QR = 'DOCUMENT_MOBILE_HANDOFF_QR',
  DOCUMENT_MOBILE_LINKED_MOBILE = 'DOCUMENT_MOBILE_LINKED_MOBILE',
  DOCUMENT_MOBILE_HANDOFF_LINKED_DESKTOP = 'DOCUMENT_MOBILE_HANDOFF_LINKED_DESKTOP',
  DOCUMENT_UPLOAD_COMPLETE = 'DOCUMENT_UPLOAD_COMPLETE',
  CAPTCHA = 'CAPTCHA',
  AUTHENTICATION = 'AUTHENTICATION',
  CONFIRM_WALLET_TRANSACTION = 'CONFIRM_WALLET_TRANSACTION',
  WALLET_OWNERSHIP = 'WALLET_OWNERSHIP',
  SELF_DECLARATION = 'SELF_DECLARATION',
  FAILED_IP_CHECK = 'FAILED_IP_CHECK',
  FAILED_VPN_CHECK = 'FAILED_VPN_CHECK',
  GENERIC_STATUS = 'GENERIC_STATUS',
  NO_FLOW = 'NO_FLOW',
  CIVIC_APP_QR = 'CIVIC_APP_QR',
  APPROVE_PII_CAPTURING = 'APPROVE_PII_CAPTURING',
  APPROVE_COLLECTED_PII_SHARING = 'APPROVE_COLLECTED_PII_SHARING',
  WALLET_TOKEN_SUCCESS = 'WALLET_TOKEN_SUCCESS',
  CIVIC_DEMO = 'CIVIC_DEMO',
  DATE_OF_BIRTH_CAPTURE = 'DATE_OF_BIRTH_CAPTURE',
  DOCUMENT_CAPTURE = 'DOCUMENT_CAPTURE',
  EMAIL_CAPTURE = 'EMAIL_CAPTURE',
  EMAIL_TOKEN_CAPTURE = 'EMAIL_TOKEN_CAPTURE',
  ERROR_UNIQUENESS = 'ERROR_UNIQUENESS',
  CHAIN_ERROR = 'CHAIN_ERROR',
  ERROR = 'ERROR',
  ZENDESK_SUPPORT = 'ZENDESK_SUPPORT',
  EXPLAINER_AGE_CHECK_13 = 'EXPLAINER_AGE_CHECK_13',
  EXPLAINER_FACE_AGE_CHECK_13 = 'EXPLAINER_FACE_AGE_CHECK_13',
  EXPLAINER_DOCUMENT = 'EXPLAINER_DOCUMENT',
  EXPLAINER_CAPTCHA = 'EXPLAINER_CAPTCHA',
  EXPLAINER_SIP = 'EXPLAINER_SIP',
  EXPLAINER_CIVIC_DEMO = 'EXPLAINER_CIVIC_DEMO',
  EXPLAINER_UNIQUENESS = 'EXPLAINER_UNIQUENESS',
  EXPLAINER_LIVENESS = 'EXPLAINER_LIVENESS',
  DOCUMENT_SELFIE_CAPTURE = 'DOCUMENT_SELFIE_CAPTURE',
  FACE_AUTHENTICATION = 'FACE_AUTHENTICATION',
  REVOCATION_FACE_SEARCH = 'REVOCATION_FACE_SEARCH',
  FACE_UNIQUENESS = 'FACE_UNIQUENESS',
  CHOOSE_WEB_OR_MOBILE = 'CHOOSE_WEB_OR_MOBILE',
  REVOCATION_IN_REVIEW = 'REVOCATION_IN_REVIEW',
  REVOCATION_QR_CODE = 'REVOCATION_QR_CODE',
  AWAITING_TXN_CONFIRMATION = 'AWAITING_TXN_CONFIRMATION',
  SIGN_TXN = 'SIGN_TXN',
  START_PRE_APPROVED_TRANSACTION = 'START_PRE_APPROVED_TRANSACTION',
  STORE_CREDENTIALS = 'STORE_CREDENTIALS',
  CHECK_FOR_EXISTING_CREDENTIALS = 'CHECK_FOR_EXISTING_CREDENTIALS',
  CHOOSE_CREDENTIALS = 'CHOOSE_CREDENTIALS',
  FUNDS_CHECK = 'FUNDS_CHECK',
}

export default { Screens };
